import EcoImg from 'eco-design/base/eco-img';
import React, { useEffect, useRef, useState } from 'react';
import { useProductMsg, useProductPageStatus } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { Spin } from 'antd-v5';
import { LoadingOutlined } from '@ant-design/icons';
import gtm from '@/utils/gtm';

const BottomAction: React.FC = () => {
    const { t } = useLang('dpux.bottomAction');
    const { locale = 'us' } = getLocal();
    const productMsg = useProductMsg();
    const pageStatus = useProductPageStatus();

    /** 显示隐藏 */
    const [isLoaded, setIsLoaded] = useState(false);
    const [show, setShow] = useState(false);
    const divRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!divRef.current) return;
        const wheelHandler = (e: WheelEvent) => {
            const delta = e.deltaY || e.detail;
            if (delta >= 20) {
                setShow(false);
            } else if (delta <= -20) {
                setShow(true);
            }
        };
        window.addEventListener('wheel', wheelHandler);
        return () => window.removeEventListener('wheel', wheelHandler);
    }, []);
    useEffect(() => {
        const handleLivechatReadyEvent = () => {
            setIsLoaded(true);
            setShow(true);
        };
        window.addEventListener('lcw:ready', handleLivechatReadyEvent);
        return () => window.removeEventListener('lcw:ready', handleLivechatReadyEvent);
    }, []);

    const handleAi = () => {
        try {
            (window as any).Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
            gtm.push({
                event: 'uaEvent',
                event_name: 'get_support',
                button_name: t('ai'),
            });
        } catch (error) {}
    };
    const handleBuy = () => {
        window.open(productMsg?.buyLink || `https://${locale}.ecoflow.com/products/delta-pro-ultra-x`);
    };

    return (
        <div className={`${css.section} ${show ? css.show : ''}`} ref={divRef}>
            <div className={`action action-ai ${isLoaded ? 'loaded' : ''}`} onClick={isLoaded ? handleAi : undefined}>
                {isLoaded ? (
                    <EcoImg className="icon-img" pc="https://websiteoss.ecoflow.com/upload/image/1759197671940/ai-icon.png" />
                ) : (
                    <Spin indicator={<LoadingOutlined spin />} size="small" />
                )}
                <span>{t('ai')}</span>
            </div>
            {pageStatus !== IPageStatus.TEASER && (
                <div className="action" onClick={handleBuy}>
                    <span>{t('buy')}</span>
                </div>
            )}
        </div>
    );
};
export default BottomAction;
